import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAnimatedScrollHandler, useSharedValue, } from 'react-native-reanimated';
import { CardView, rem } from 'design-system';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useFocusEffect } from 'hooks';
import Amount from 'design-system/Amount';
import { selectDefaultCurrency } from 'reducers/selectors';
import Text from 'design-system/Text';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import useColors from 'hooks/useColors';
import Modal from 'utils/packages/Modal';
import { getCreditAndDebt } from '../actions/payments';
import { selectCreditAndDebtAmounts } from '../selectors';
import { CreditAndDebtModalContent } from './CreditAndDebtModalContent';
const strings = {
    credit: 'Friends owe you',
    creditBtn: 'Remind',
    debt: 'Friends you owe',
    debtBtn: 'Pay',
};
export const CreditAndDebtSection = ({ cardViewStyle, }) => {
    const { credit, debt } = useAppSelector(selectCreditAndDebtAmounts);
    const currency = useAppSelector(selectDefaultCurrency);
    const dispatch = useAppDispatch();
    useFocusEffect(useCallback(() => {
        dispatch(getCreditAndDebt());
    }, []));
    const colors = useColors();
    const scrollValue = useSharedValue(0);
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        scrollValue.value = handle.contentOffset.y;
    }, []);
    const showModal = useCallback((flow) => {
        if ((flow === 'credit' && !credit) || (flow === 'debt' && !debt)) {
            return;
        }
        Modal.show(<CreditAndDebtModalContent flow={flow} onScroll={scrollHandler}/>, {
            containerStyle: styles.modal,
            title: flow === 'credit' ? strings.credit : strings.debt,
            scrollable: { scrollValue },
        });
    }, [credit, debt, scrollHandler, scrollValue]);
    return (<CardView noMarginBottom style={[styles.container, cardViewStyle]}>
      <TouchableHighlight onCard hoverOnLight activeOpacity={1} onPress={() => showModal('credit')} style={styles.flex} underlayColor={colors.background.underlay}>
        <View style={styles.item}>
          <Amount Numbers-20 value={{ amount: credit ?? 0, currency }}/>
          <Text TextThin-14 Secondary>
            {strings.credit}
          </Text>
        </View>
      </TouchableHighlight>
      <TouchableHighlight onCard hoverOnLight activeOpacity={1} onPress={() => showModal('debt')} style={styles.flex} underlayColor={colors.background.underlay}>
        <View style={styles.item}>
          <Amount Numbers-20 value={{ amount: debt ?? 0, currency }}/>
          <Text TextThin-14 Secondary>
            {strings.debt}
          </Text>
        </View>
      </TouchableHighlight>
    </CardView>);
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    flex: {
        flex: 1,
    },
    container: {
        flexDirection: 'row',
        overflow: 'hidden',
    },
    item: {
        padding: rem(16),
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
